import { Box, BoxProps, Center, HStack, Text } from '@chakra-ui/react';
import { StaticImageData } from 'next/image';
import { useTranslation } from 'next-i18next';
import { FC } from 'react';
import { ResponsiveValue } from '@/shared/types';
import Image from '../Image';

export interface ThumbnailsProps extends BoxProps {
  images: {
    id: string;
    src: string | StaticImageData;
    alt?: string;
  }[];
  selectedImageIndex?: number;
  size?: BoxProps['boxSize'];
  unoptimized?: boolean;
  disableFullView?: boolean;
  onImageClick?: (index: number) => void;
  imgSizes?: ResponsiveValue | string;
}

const Thumbnails: FC<ThumbnailsProps> = ({
  images,
  size = '5rem',
  unoptimized,
  selectedImageIndex,
  disableFullView,
  imgSizes = '5rem',
  onImageClick,
  ...styles
}) => {
  const { t } = useTranslation();

  return (
    <Box
      h='auto'
      overflowX='scroll'
      overflowY='hidden'
      position='relative'
      width='full'
      {...styles}
    >
      {!images.length ? (
        <Center
          height={{ base: 32, md: 40 }}
          width='full'
        >
          <Text color='gray.base'>{t('common.noImages')}</Text>
        </Center>
      ) : (
        <HStack
          alignItems='flex-start'
          p={1}
          spacing={4}
          width='max-content'
        >
          {images.map((image, index) => {
            const isActive = selectedImageIndex === index;

            return (
              <Image
                key={image.id}
                _hover={{ cursor: !!onImageClick ? 'pointer' : 'default' }}
                alt={image.alt}
                borderRadius='lg'
                boxSize={size}
                imgSizes={imgSizes}
                outline={isActive ? '2px solid' : 'none'}
                outlineColor={isActive ? 'primary.pure' : 'transparent'}
                outlineOffset={-1}
                src={image.src}
                unoptimized={unoptimized}
                onClick={() => onImageClick?.(index)}
              />
            );
          })}
        </HStack>
      )}
    </Box>
  );
};

export default Thumbnails;
